<template>
    <div class="surface-list">
        <v-subheader>{{ $t('steps.surface.surface') }}</v-subheader>
        <v-btn v-for="(surface, index) in surfaces"
               :key="index"
               fab
               large
               color="blue"
               :disabled="index === current"
               class="surface-list-button"
               @click="current = index">
            <v-btn
                v-if="editable && index !== current && index !== 0"
                absolute dark fab top right x-small
                class="surface-list-button-remove"
                color="red"
                @click.stop="removeSurface(index)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
            {{ index + 1 }}
        </v-btn>
        <v-btn v-if="editable" fab large class="surface-list-button" color="light-green" :disabled="surfaces.length > 5" @click="appendSurface">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "SurfaceList",
        props: ['editable'],
        computed: {
            surfaces() {
                return this.$store.state.configurator.surfaces
            }
        },
        data() {
            return {
                current: 0
            }
        },
        methods: {
            appendSurface() {
                this.$store.commit('appendSurface')
                this.current = this.surfaces.length - 1
            },
            removeSurface(index) {
                if(index < this.current) {
                    this.current--
                }
                this.$store.commit('removeSurface', index)
            }
        },
        watch: {
            current(value) {
                this.$emit('current', value)
            }
        }
    }
</script>

<style scoped>

    .surface-list {
        margin: 10px 10px 20px;
    }
    .surface-list-button {
        font-size: 24px;
        color: #fff;
        font-weight: bold;
        margin: 5px;
    }
    .surface-list-button-remove {
        top: -28px;
        right: -10px;
    }
</style>
